module.exports = __webpack_public_path__ + "static/media/map-signs.b0c1e4d4.svg";